import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-off",
  "use": "icon-off-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-off\"><defs><style type=\"text/css\"></style></defs><path d=\"M847.65 248.03l-67.1 52.72c47.62 60.59 72.78 133.46 72.78 210.71 0 188.21-153.12 341.33-341.33 341.33S170.67 699.68 170.67 511.47c0-77.21 25.14-150.03 72.69-210.6l-67.12-52.7c-59.47 75.75-90.91 166.79-90.91 263.3 0 235.26 191.4 426.67 426.67 426.67s426.67-191.4 426.67-426.67c0-96.57-31.48-187.67-91.02-263.44z\" p-id=\"3758\" /><path d=\"M469.33 85.33h85.33v469.33h-85.33z\" p-id=\"3759\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/off.svg
// module id = 4cs8
// module chunks = 65